import React from "react"
import { useFormContext } from "react-hook-form"

import { TARGETED_OFFICIALS_DEFAULT_SELECTION_ERROR } from "@/pages/campaign-form/constants"
import { SafedSearch } from "@/types/djangio"
import { ControlledSelectableBadge } from "@/components/Controlled/ControlledSelectableBadge"

const defaultTypeOfOfficials = [
    { label: "Federal Senators", value: DjangIO.app.person.newtypes.MinorRoleType.us_senator.value },
    { label: "Federal Representatives", value: DjangIO.app.person.newtypes.MinorRoleType.us_representative.value },
    { label: "State Senators", value: DjangIO.app.person.newtypes.MinorRoleType.us_state_senator.value },
    { label: "State Representatives", value: DjangIO.app.person.newtypes.MinorRoleType.us_state_representative.value },
    { label: "Governors", value: DjangIO.app.person.newtypes.MinorRoleType.us_governor.value },
    { label: "Mayors", value: DjangIO.app.person.newtypes.MinorRoleType.us_local_muni_mayor.value },
    { label: "City Council Members", value: DjangIO.app.person.newtypes.MinorRoleType.us_local_muni_legislator.value },
] as const

export const StandardOfficialSelector = ({ name, label }) => {
    const formContext = useFormContext()
    const safedSearchTemplate = formContext.watch(name) as SafedSearch
    return (
        <ControlledSelectableBadge
            label={label}
            data={defaultTypeOfOfficials}
            name={name}
            withAsterisk
            transform={{
                input: (input: SafedSearch): number[] => {
                    return input?.filters?.[0]?.ph_minor_role_type || []
                },
                output: (output: number[]) => {
                    return {
                        ...safedSearchTemplate,
                        filters: [{ ph_minor_role_type: output }],
                    }
                },
            }}
            rules={{
                validate: (value) =>
                    (value && value.filters?.[0]?.ph_minor_role_type.length > 0) ||
                    TARGETED_OFFICIALS_DEFAULT_SELECTION_ERROR,
            }}
        />
    )
}
